// Simple request deduplication to prevent duplicate API calls
class SimpleRequestDeduplication {
  private pendingRequests = new Map<string, Promise<unknown>>();

  async deduplicateRequest<T>(
    key: string,
    requestFn: () => Promise<T>
  ): Promise<T> {
    // If request already in progress, return existing promise
    if (this.pendingRequests.has(key)) {
      return this.pendingRequests.get(key) as Promise<T>;
    }

    // Create new request
    const requestPromise = requestFn().finally(() => {
      this.pendingRequests.delete(key);
    });

    this.pendingRequests.set(key, requestPromise);
    return requestPromise;
  }

  // Clear specific request (for cleanup)
  clearRequest(key: string): void {
    this.pendingRequests.delete(key);
  }

  // Clear all requests (for cleanup)
  clearAll(): void {
    this.pendingRequests.clear();
  }
}

export const simpleDeduplication = new SimpleRequestDeduplication();
